import request from "../utils/request";

const schemeApi = {
    SchemeList: 'classify/tag',
    TransferPage: "classify/tag/page",
    TransferTotal: "classify/tag/total",
}
export function addTag(parameter) {
    return request({
        url: schemeApi.SchemeList,
        method: "post",
        data: parameter,

    })
}

export function getTag({ type, page, size, need_page }) {
    return request({
        url: schemeApi.SchemeList,
        method: "get",
        params: {
            type,
            page,
            size,
            need_page
        },

    })
}

export function deleteTagApi(id) {
    return request({
        url: schemeApi.SchemeList + '/' + id,
        method: "delete",
    })
}

export function TransferTag(obj) {
    return request({
        url: schemeApi.TransferPage,
        method: "PATCH",
        data: obj,

    })
}

export function removeTagPage(obj) {
    return request({
        url: schemeApi.TransferPage,
        method: "DELETE",
        data: obj,

    })
}
// 所有页转移标签
export function TransferTagTotal(obj) {
    return request({
        url: schemeApi.TransferTotal,
        method: "PATCH",
        data: obj,

    })
}
// 所有页移出标签
export function removeTagTotal(obj) {
    return request({
        url: schemeApi.TransferTotal,
        method: "DELETE",
        data: obj,

    })
}
// 本页打标签
export function classfiyTagPage(obj) {
    return request({
        url: schemeApi.TransferPage,
        method: "POST",
        data: obj,

    })
}
// 所有页打标签
export function classfiyTagTotal(obj) {
    return request({
        url: schemeApi.TransferTotal,
        method: "POST",
        data: obj,

    })
}